import React from 'react';

import Spacing from '@marvelapp/marvel-ui/spacing';

import Page from 'marketing-website/components/modules/Page';
import metaData from 'marketing-website/data/metadata.js';

import WebinarsBlock from './_WebinarsBlock.js';
import BitsAndBobs from './_BitsAndBobs.js';
import ProductUpdates from './_ProductUpdates.js';
import HeadingCards from './_HeadingCards.js';

import styles from './styles/general.module.css';

export default function ResourceLanding() {
  const {
    resources: { homepage },
  } = metaData;
  const pageProps = {
    title: homepage.title,
    meta: [
      {
        name: 'description',
        content: homepage.description,
      },
    ],
    header: {
      title: 'Resources',
      isResources: true,
    },
    footer: true,
    banner: false,
  };
  return (
    <Page {...pageProps}>
      <div className={styles.wrap}>
        <HeadingCards />

        <a name="webinars" />
        <Spacing type="padding" position="top" size="l">
          <WebinarsBlock />
        </Spacing>

        <a name="productupdates" />
        <Spacing type="padding" position="top" size="l">
          <ProductUpdates />
        </Spacing>

        <a name="bits+bobs" />
        <Spacing type="padding" position="top" size="l">
          <BitsAndBobs />
        </Spacing>
      </div>
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/resources/index.js